// src/components/ProtectedRoute.jsx
import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { currentUser, authReady, isAdmin } = useContext(AuthContext);
  const location = useLocation();

  // Keep users on the page until Firebase auth state is fully resolved
  if (!authReady) {
    return <AuthGateLoader />;
  }

  if (!currentUser) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;

const AuthGateLoader = () => {
  return <div className="fullscreen-loader">Securing your session...</div>;
};
